import React from 'react';
import Status, { type Props as StatusProps } from '~/components/atom/Status';

const LfaSettingsStatus: React.FC<StatusProps> = props => (
  <Status width="100%" lineHeight="m" {...props} />
);

export default LfaSettingsStatus;
